import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class Footer extends React.Component<any, any>{


    render() {
        const {t} = this.props;

        return (
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-xs-12 text-center">
                            <h2> <img src="/img/logo_footer.png" /> <small className="text-white badge badge-danger">18+</small></h2>
                            <ul className="social">
                                <li> <a href="https://www.facebook.com/OkayUzMedia/" target="_blank"><i
                                    className="fa fa-facebook"></i></a> </li>
                                <li> <a href="#"><i className="fa fa-twitter"></i></a> </li>
                                <li> <a href="https://t.me/okayofficial" target="_blank"><i className="fa fa-telegram"></i></a>
                                </li>
                                <li> <a href="#"><i className="fa fa-google"></i></a> </li>
                                <li> <a href="#"><i className="fa fa-instagram"></i></a> </li>
                            </ul>
                        </div>
                        <div className="col-md-8 col-xs-12">
                            <div className="border_box">
                                <ul className="menu">
                                    <li> <NavLink to="/about"> {t("О проекте")} </NavLink> </li>
                                    <li> <NavLink to="/partners"> {t("Правообладателям")} </NavLink> </li>
                                    <li> <NavLink to="/agreement"> {t("Пользовательская соглашения")} </NavLink> </li>
                                    <li> <NavLink to="/feedback"> {t("Обратная связь")} </NavLink> </li>
                                    <li> <NavLink to="/reklama"> {t("Реклама на сайте")} </NavLink> </li>
                                </ul>
                                <p>{t("Видео и аудио записи предназначены исключительно для предварительного ознакомительного просмотра (прослушивания). Все права на исходные видеоматериалы принадлежат соответствующим организациям...")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright">
                    <div className="container">
                        <div className="row">
                            <div className="left"> © {new Date().getFullYear()} {window.location.host.toUpperCase()} </div>
                            <div className="right"> {t("Сайт разработан")} <a target="_blank" href="http://sd.uz"> SD.uz </a></div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default withTranslation()(Footer);